import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";

export const changeOrderWhere = (user: User) => {
  if (hasCapability(user, "changeOrder.read")) {
    return {};
  }
  return { AND: [{ id: NON_EXISTENT_ID }] };
};

export const changeOrder = {
  adjustMargin: (user: User) => hasCapability(user, "changeOrder.adjustMargin"),
  create: (user: User) => hasCapability(user, "changeOrder.create"),
  read: (user: User) => hasCapability(user, "changeOrder.read"),
  readCostBasis: (user: User) => hasCapability(user, "changeOrder.readCostBasis"),
  // Cancel reuses the edit gate (workOrder.create gates updateChangeOrder): anyone who can edit a change order can cancel it.
  cancel: (user: User, submitter: { organizationId: string | null }) => {
    if (hasCapability(user, "workOrder.create")) {
      return true;
    }
    return (
      hasCapability(user, "changeOrder.create") &&
      submitter.organizationId !== null &&
      user.person.organizationId === submitter.organizationId
    );
  },
};
